import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/**
 * Atalho para a escolha de assento do app (`flight_seat_link`) — o agente de viagem o emite
 * quando a pessoa pede para escolher o assento de um voo JÁ EMITIDO. Uma linha por voo (até 6,
 * o teto do frame), cada uma com a SUA viagem: o card pode listar voos de várias viagens
 * abertas. O botão despacha `open-trip` (client-side) para
 * `/trips/:tripId?voucher=<código>&flow=seat[&dir=<sentido>]`; `title` é a copy da linha, do
 * produtor. `direction` é o sentido do trecho que a linha descreve: um bate-volta com a ida já
 * partida aponta a VOLTA, e sem o sentido a gaveta abriria na ida (o primeiro passo). Opcional
 * (aditivo): bloco persistido antes dele segue válido e a gaveta abre como sempre.
 */
const FlightSeatLinkFlightSchema = z.object({
  tripId: z.string().min(1),
  voucherCode: z.string().min(1),
  title: z.string().min(1),
  direction: z.enum(['outbound', 'return']).optional(),
});

/** Membro `flight_seat_link` do `ChatUiSchema` (discriminatedUnion). */
export const FlightSeatLinkBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('flight_seat_link'),
    flights: z.array(FlightSeatLinkFlightSchema).min(1).max(6),
  })
  .strict();
export type FlightSeatLinkBlock = z.infer<typeof FlightSeatLinkBlockSchema>;
